export default "__VITE_ASSET__DlxdcuXC__"